export const generateCompactLayout = ({ settings, albumArt, buttonStyle }) => `
<div id="radio-player" class="radio-player compact">
    ${albumArt !== 'disable' ? `
    <div class="album-artwork">
        <img class="artwork-image" src="" alt="Album Art" style="display: none;" />
        <div class="artwork-placeholder">ALBUM ARTWORK AREA</div>
    </div>
    ` : ''}

    <div class="compact-header">
        ${settings?.radioName ? '<div class="radio-name"></div>' : ''}
        ${settings?.liveIndicator ? `
        <div class="live-container">
            <div class="live-indicator"></div>
            <div class="live-text">LIVE</div>
        </div>
        ` : ''}
    </div>

    <div class="song-info">
        ${settings?.songName ? '<div class="song-name"></div>' : ''}
        ${settings?.artistName ? '<div class="artist-name"></div>' : ''}
    </div>

    <div class="controls-container">
        <div class="controls">
            ${settings?.songHistory ? `
            <button class="control-button history-button">
                ${buttonStyle === 'text' ? 'History' : '<i class="fas fa-history"></i>'}
            </button>
            ` : ''}
            <button class="control-button play-button">
                ${buttonStyle === 'text' ? 'Play' : '<i class="fas fa-play"></i>'}
            </button>
            ${settings?.volumeControl ? `
            <button class="control-button volume-button">
                ${buttonStyle === 'text' ? 'Volume' : '<i class="fas fa-volume-up"></i>'}
            </button>
            <div class="volume-bar-container">
                <input type="range" class="volume-slider" min="0" max="100" value="100">
            </div>
            ` : ''}
        </div>
    </div>

    ${settings?.time ? `
    <div class="time-info">
        <span class="elapsed-time">0:00</span>
        <span class="duration-time">0:00</span>
    </div>
    ` : ''}

    ${settings?.timeBar ? `
    <div class="time-bar-container">
        <div class="time-bar">
            <div class="time-bar-progress"></div>
        </div>
    </div>
    ` : ''}
</div>

<!-- History Modal - Moved outside radio player -->
${settings?.songHistory ? `
<div class="history-modal" style="display: none;">
    <div class="history-modal-overlay"></div>
    <div class="history-modal-content">
        <h3 class="history-modal-title">${settings.historyHeaderText || 'Song History'}</h3>
        <button class="history-modal-close">
            <i class="fas fa-times"></i>
        </button>
        <div class="history-list"></div>
    </div>
</div>
` : ''}`; 